<template>
    <div>
        <div class="lke-bg">
            <div class="lke-top">
                <div class="lke-top-title">
                    <i class="el-icon-s-home"></i>
                    <span>当前位置:</span>
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item>
                            <router-link to="/" style="text-decoration:none">
                        <el-link>首页</el-link>
                        </router-link>
                        </el-breadcrumb-item>
                        <el-breadcrumb-item>
                            <el-link style="cursor: pointer;" type="info">名师</el-link>
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>
            <div class="lke-text-bg">
                <div class="lke-mid-top">
                    <!-- <i class="el-icon-s-order"></i> -->
                    名师风采
                </div>
                <div>
                    <el-table
                    :data="list"
                    v-loading="loading"
                    style="width: 100%">
                    <el-table-column
                    label="老师姓名"
                        prop="name">
                        <template slot-scope="{row}">
                            <router-link :to="'/msfc/'+row._id" style="text-decoration:none">
                                <el-link type="primary">{{row.title}}</el-link>
                            </router-link>
                        </template>
                    </el-table-column>
                    <el-table-column
                    label="发布时间"
                        width="180">
                        <template slot-scope="{row}">
                            <span>{{row.releaseTime | addtime}}</span>
                        </template>
                    </el-table-column>
                    </el-table>
                </div>
                <div class="lke-bott">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage1"
                    :page-size="20"
                    layout="total, prev, pager, next"
                    :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getnotice } from "@/api/index"
import moment from "moment";
export default {
    props: {

    },
    data() {
        return {
            loading: true,
            page: 1,
            total: 0,
            currentPage1: 5,
            list: []
        };
    },
    filters: {
         addtime(val) {
            return moment(val).format("YYYY-MM-DD");
        },
    },
    computed: {

    },
    created() {
        this.getInfo()
    },
    mounted() {

    },
    watch: {

    },
    methods: {

        getInfo() {
            this.loading = true;
            let obj = {
                type: 'teacher',
                limit: 20,
                page: this.page
            }
            getnotice(obj).then(response =>{
                this.list = response.result;
                this.total = response.count;
            })
            this.loading = false
         },

        handleSizeChange(val) {
        
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getInfo()
        }

    },
    components: {

    },
};
</script>

<style>
.el-table__row{
    cursor: pointer;
}
</style>

<style scoped>
.lke-bg{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding-bottom: 60px;
}
.lke-top{
    width: 944px;
    padding: 20px 40px ;
}
.lke-top-title{
    display: flex;
    align-items: center;
    font-size: 14px;
}
.lke-top-title > i{
    color: #2890F4;
    font-size: 20px;
}
.lke-top-title > span{
    margin-left: 5px;
    margin-right: 10px;
}
.lke-text-bg{
    width: 944px;
    margin: 0 20px;
    padding: 20px 20px;
    border-radius: 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    background: #FFFFFF;
}
.lke-mid-top{
    padding: 10px 20px;
    font-size: 18px;
    color: #abbbcc;
    display: flex;
    align-items: center;
    font-weight: bold;
    border-bottom: 1px solid #ccc;
    color: #2890F4;
}
.lke-mid-top > i{
    font-size: 30px;
    padding-right: 20px;
}
.lke-bott{
    text-align: center;
    padding-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/msfc/index.vue